module.exports = __webpack_public_path__ + "img/motorcycle-none-right.d3ddc701.jpg";